// src/pages/Admin/EditProduct.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import AddProduct from "./AddProduct";
import { useAdmin } from "../../../context/AdminContext";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAdmin();

  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);

  // -------------------------
  // FETCH PRODUCT (FIXED)
  // -------------------------
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const { data } = await axios.get(`${API}/api/products/${id}`);

        setProductData({
          ...data,
          otherImages: data.otherImages || [],
        });

      } catch (err) {
        console.error(err.response?.data || err);
        alert("Failed to fetch product data.");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  // -------------------------
  // SUCCESS HANDLER
  // -------------------------
  const handleUpdateSuccess = () => {
    navigate("/admin/manage-products");
  };

  // -------------------------
  // LOADING STATE
  // -------------------------
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800 text-white">
        <div className="text-center space-y-3">
          <div className="w-10 h-10 border-4 border-white/20 border-t-white rounded-full animate-spin mx-auto"></div>
          <p className="text-gray-300 text-sm">Loading product...</p>
        </div>
      </div>
    );
  }

  // -------------------------
  // NOT FOUND STATE
  // -------------------------
  if (!productData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800 text-red-400">
        Product not found.
      </div>
    );
  }

  // -------------------------
  // UI
  // -------------------------
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800 text-white p-4 sm:p-6 lg:p-10">

      <div className="flex items-center justify-between mb-8">
        <div className="w-[90px]" />
      </div>

      <div className="w-full">
        <AddProduct
          prefill={productData}
          productId={id}
          onSuccess={handleUpdateSuccess}
          token={token}
        />
      </div>

    </div>
  );
};

export default EditProduct;
